import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 border-t border-background-800/60">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="lg:w-1/3">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-spy-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-foreground-50 tracking-wide" style={{ fontFamily: "var(--font-heading)" }}>
                黑网料
              </span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed mb-4">
              黑网料是专注收录网络深度内幕、爆料资讯与隐秘信息的聚合平台。汇聚真实黑网料来源，帮助用户快速获取被删除、被屏蔽的第一手内幕内容，洞察信息背后的真相。
            </p>
            <p className="text-foreground-600 text-xs">
              <strong>声明：</strong>本站内容来源于公开网络信息与用户投稿，仅供信息参考，不代表本站立场。
            </p>
          </div>

          <div className="flex flex-wrap gap-10 lg:gap-16">
            <div>
              <h4 className="text-foreground-200 text-sm font-semibold mb-4 tracking-wide" style={{ fontFamily: "var(--font-heading)" }}>内容分类</h4>
              <div className="flex flex-col gap-2.5">
                {[
                  { label: '政治内幕', path: '/category/zhengzhi-neimu' },
                  { label: '商业黑幕', path: '/category/shangye-heimu' },
                  { label: '科技揭秘', path: '/category/keji-jiemi' },
                  { label: '社会爆料', path: '/category/shehui-baoliao' },
                  { label: '娱乐圈', path: '/category/yule-quan' },
                  { label: '国际风云', path: '/category/guoji-fengyun' },
                ].map((item) => (
                  <Link key={item.path} to={item.path} className="text-foreground-500 hover:text-primary-400 text-sm transition-colors duration-200">
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-foreground-200 text-sm font-semibold mb-4 tracking-wide" style={{ fontFamily: "var(--font-heading)" }}>关于我们</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/about" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors duration-200">品牌介绍</Link>
                <Link to="/about" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors duration-200">信誉背书</Link>
                <Link to="/about" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors duration-200">联系我们</Link>
                <Link to="/" className="text-foreground-500 hover:text-primary-400 text-sm transition-colors duration-200">投稿通道</Link>
              </div>
            </div>
            <div>
              <h4 className="text-foreground-200 text-sm font-semibold mb-4 tracking-wide" style={{ fontFamily: "var(--font-heading)" }}>关注我们</h4>
              <div className="flex gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-200" rel="nofollow" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-200" rel="nofollow" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-200" rel="nofollow" aria-label="Telegram">
                  <i className="ri-telegram-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-200" rel="nofollow" aria-label="RSS">
                  <i className="ri-rss-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-background-800/60">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-600 text-xs">
            &copy; 2026 黑网料 Heiwangliao. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors duration-200">隐私政策</a>
            <a href="#" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors duration-200">用户协议</a>
            <a href="#" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors duration-200">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}